import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RestapiService } from './services/restapi.service';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { EndlessBlowComponent } from './components/portfolio/endless-blow/endless-blow.component';
import { TextEffectComponent } from './components/text-effect/text-effect.component';
import { PortfolioComponent } from './components/portfolio/portfolio.component';
import { AppLocationComponent } from './components/portfolio/app-location/app-location.component';
import { ObjectsMeasurementComponent } from './components/portfolio/objects-measurement/objects-measurement.component';
import { DribblerComponent } from './components/portfolio/dribbler/dribbler.component';
import { NotepadComponent } from './components/portfolio/notepad/notepad.component';
import { EndlessBlowResetPasswordComponent } from './components/portfolio/endless-blow/endless-blow-reset-password/endless-blow-reset-password.component';
import { NotFoundComponent } from './components/errors/not-found/not-found.component';
import { AboutComponent } from './components/about/about.component';
import { ProductNotesComponent } from './components/portfolio/product-notes/product-notes.component';
import { AssocWordsComponent } from './components/portfolio/assoc-words/assoc-words.component';
import { ExchangeRatesComponent } from './components/portfolio/exchange-rates/exchange-rates.component';
import { RickAndMortyComponent } from './components/portfolio/rick-and-morty/rick-and-morty.component';
import { AiBasedAudioProcessingComponent } from './components/portfolio/ai-based-audio-processing/ai-based-audio-processing.component';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    EndlessBlowComponent,
    TextEffectComponent,
    PortfolioComponent,
    AppLocationComponent,
    ObjectsMeasurementComponent,
    DribblerComponent,
    NotepadComponent,
    EndlessBlowResetPasswordComponent,
    NotFoundComponent,
    AboutComponent,
    ProductNotesComponent,
    AssocWordsComponent,
    ExchangeRatesComponent,
    RickAndMortyComponent,
    AiBasedAudioProcessingComponent
  ],
    imports: [
        BrowserModule,
        RouterModule,
        AppRoutingModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule
    ],
  providers: [RestapiService],
  bootstrap: [AppComponent]
})
export class AppModule { }
